import {makeAutoObservable} from 'mobx';

import type {ModalController} from './Modal.controller';

export class ModalNodesManager {
  constructor(private readonly controller: ModalController) {
    makeAutoObservable(this, undefined, {autoBind: true});
  }

  getFooter() {
    return document.getElementById(this.controller.selectors.footerContainerId);
  }

  getHeader() {
    return document.getElementById(this.controller.selectors.headerWrapperId);
  }

  getOverlay() {
    return document.getElementsByClassName(
      this.controller.selectors.overlayClassName,
    )[0];
  }

  getParent(): HTMLElement {
    return (
      document.querySelector(
        this.controller.modalService.config.mountElementSelector,
      ) ?? document.body
    );
  }

  getScrollContainer() {
    return document.getElementById(this.controller.selectors.scrollContainerId);
  }
}
